<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller"/>

    <!-- HEADER -->
    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-7 col-md-10">
              <h1 class="display-3 text-white">Crear Modelo</h1>
              <p class="text-white mt-0 mb-5">Los modelos seran parte de lista blanca</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-sm-12">
          <div class="card card-body">
            <my-spinner :loading="filters.loading"/>
            <div class="row">
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <select class="form-control form-control-alternative" v-model="filters.selected.category">
                    <option value="">Selecciona la categoría</option>
                    <option v-for="s in filters.categorys" :value="s.value" :key="s.value">{{s.caption}}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <select class="form-control form-control-alternative" v-model="filters.selected.brand">
                    <option value="">Selecciona una marca</option>
                    <option v-for="s in filters.brands" :value="s.caption" :key="s.value">{{s.caption}}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <select class="form-control form-control-alternative" v-model="filters.selected.bodytype">
                    <option value="">Selecciona la carrocería</option>
                    <option v-for="s in filters.bodytypes" :value="s.value" :key="s.value">{{s.caption}}</option>
                  </select>
                </div>
              </div>   
              <hr>                        
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <select class="form-control form-control-alternative" v-model="filters.selected.transmission">
                    <option value="">Selecciona la transmisión</option>
                    <option v-for="s in filters.transmissions" :value="s.value" :key="s.value">{{s.caption}}</option>
                  </select>
                </div>
              </div>  
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <select class="form-control form-control-alternative" v-model="filters.selected.year">
                    <option value="0">Seleccione el año</option>
                    <option v-for="s in filters.years" :value="s.value" :key="s.value">{{s.caption}}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <select class="form-control form-control-alternative" v-model="filters.selected.fuel">
                    <option value="0">Selecciona el combustible</option>
                    <option v-for="s in filters.fuels" :value="s.value" :key="s.value">{{s.caption}}</option>
                  </select>
                </div>
              </div>            
              <div class="col-sm-3">
                <div class="form-group mb-0">
                  <input class="form-control form-control-alternative" type="text" placeholder="ingrese modelo" v-model="filters.selected.model" maxlength="20" />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group mb-0">
                  <button class="btn btn-success" @click="setInfo()" :disabled="_disabledBtn" >CREAR MODELO</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row row-asociations" v-if="filters.result.data">
        <my-spinner :loading="loading"/>
        <div class="col-sm-4">
          <div class="card shadow card-records">
            <div class="card-header bg-info text-white">{{filters.result.customMessage}}</div>
            <div class="card-body bg-secondary">
              <div class="card card-stats card-item-rc">
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <h5 class="card-title text-uppercase mb-0">id: {{filters.result.data.id}}</h5>
                      <hr>
                      <h5 class="card-title text-uppercase mb-0">Marca: {{filters.result.data.nombreMarca}}</h5>
                      <hr>
                      <h5 class="card-title text-uppercase mb-0">Modelo: {{filters.result.data.nombreModelo}}</h5>
                      <hr>
                      <h5 class="card-title text-uppercase mb-0">Año: {{filters.result.data.agno}}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    
  </div>
</template>
<script>
import Auth from '@/helpers/middleware'
import sysMsgs from '@/helpers/system.message'
import GlobalServices from "@/services/globals.services";
import WhiteListServices from "@/services/whitelist.services";
import _ from 'underscore';
import { CreateModel } from '@/views/operaciones/listablanca/modelos/models/modelos.model';

export default {
  name: "ModelosWhiteList",
  data() {
    return {
      actions: Auth.getActions(this.$route.name),
      controller: {
        title: "Operaciones",
        mainRouter: "/operaciones/clasificaciones"
      },
      filters:{
        fuels:[],
        transmissions: GlobalServices.filters.transmissions(),
        bodytypes:[],
        brands:[],
        categorys:[],
        years:[],
        selected:{
          category:"",
          fuel:0,
          transmission: "",
          bodytype:"",
          brand: "",
          model: "",
          year: 0
        },
        result: {},
        loading: true,
        notvalidate:[
          "transmission",
          "fuel",
          "bodytype"
        ]
      },
      createModel: new CreateModel(),
      loading: false,
      messages:{
        danger:"¡Advertencia! Existe más de una versión premium seleccionada",
        warning:"¡Advertencia! se actualizarán todos los registros asociados a la lista premium"
      }
    };
  },
  computed: {
    _disabledBtn(){
      let validate = 0;
      _.each(this.filters.selected, (value, field)=>{
        if(!_.contains(this.filters.notvalidate, field)){
          validate = value.toString().trim().length == 0 || value == 0 ? validate + 1 : validate;
        }
      });
      
      return validate > 0 ? true : false;
    }
  },
  watch:{
    'filters.selected.category':{
      handler(data){
        this.filters.selected.year = 0;
        this.filters.selected.brand = "";
        this.filters.selected.bodytype = "";
        this.filters.selected.transmission = "";
        this.filters.selected.fuel = 0;
        this.filters.selected.model = "";
        this.filters.result = {};
        if(data){
          let objBrand = { idCat: data };
          this.getBrands(objBrand);
        }
      }
    }
  },
  methods: {
    
    getCategorys(){
      GlobalServices.filters.categorys()
      .then(response => { this.filters.categorys = _.map(response.data, m => { return {caption: m.categoria, value: m.idCategoria} }); this.filters.loading = false; })
      .catch(error => {
        sysMsgs.getResponseMessage(error.response);
        this.filters.loading = false;
      });
    },
    getYears(){
      GlobalServices.filters.years()
      .then(response => { this.filters.years = _.map(response.data, m => { return {caption: m.ano, value: m.codAno} }); this.filters.loading = false; })
      .catch(error => {
        sysMsgs.getResponseMessage(error.response);
        this.filters.loading = false;
      });
    },
    getFuels(){
      GlobalServices.filters.fuels()
      .then(response => { this.filters.fuels = _.map(response.data, m => { return {caption: m.combustible, value: m.codCombustible} }); })
      .catch(error => {
        sysMsgs.getResponseMessage(error.response);
        this.filters.loading = false;
      });
    },
    getBodyTypes(data){
      GlobalServices.filters.bodytypes(data)
      .then(response => { this.filters.bodytypes = _.map(response.data, m => { return {caption: m.carroceria, value: m.cod_carroceria} }); this.filters.loading = false; })
      .catch(error => {
        sysMsgs.getResponseMessage(error.response);
        this.filters.loading = false;
      });
    },
    getBrands(data){
      this.filters.loading = true;
      GlobalServices.filters.brands(data)
      .then(response => { this.filters.brands = _.map(response.data.marcas, m => { return {caption: m.marca, value: m.codMarca} }); this.getBodyTypes(data.idCat); })
      .catch(error => {
        sysMsgs.getResponseMessage(error.response);
        this.filters.loading = false;
      });;
    },
    setInfo(evt){
      sysMsgs.getConfirm("Confirmar creación del modelo", "").then(result => {
          if (result.value) {
            this.loading = true;
            let post = new CreateModel(0, 
                                      this.filters.selected.category,
                                      this.filters.selected.brand, 
                                      this.filters.selected.model,
                                      this.filters.selected.year,
                                      this.filters.selected.bodytype,
                                      this.filters.selected.transmission,
                                      this.filters.selected.fuel);
                                        
            WhiteListServices.save.setInfo(post).then(response => { 
              this.loading = false;
              sysMsgs.getMessage('Registro actualizado','success');
              this.filters.result = response.data;
            }).catch(error => {
              sysMsgs.getResponseMessage(error.response);
              console.log(error.response.data);
              this.loading = false;
            }); 
          }
        })
    }
  },
  created() {
    this.getCategorys();
    this.getYears();
    this.getFuels();
  }
};
</script>

<style scoped>
.btn-select {
  color: #ddd;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px 10px;
}
.btn-select.active {
    color: #fff;
    background-color: #2dce89 ;
    border: 1px solid #2dce89;

}
.loading-overlay{
  left: 0;
  top: 0;
}
</style>
